module.exports = __webpack_public_path__ + "img/footer2.d99931d6.png";